let read_more = document.querySelectorAll(
  ".product-description-container[read-more-qf]"
);

const readMoreLabel =
  window.themeStrings?.readMore || "Read more";
const readLessLabel =
  window.themeStrings?.readLess || "Read less";

read_more.forEach((el) => {
  let read_more_control = el.querySelector(".read-more");
  let excerpt = el.querySelector("span.excerpt");
  let full = el.querySelector("span.full");

  read_more_control.addEventListener("click", () => {
    if (el.classList.contains("active")) {
      el.classList.remove("active");
      read_more_control.innerHTML = readMoreLabel;
    } else {
      el.classList.add("active");
      read_more_control.innerHTML = readLessLabel;
    }
  });
});
